<h3 style="text-align: center; margin-top: 0px;">{{selectedGroupInfo?.name }} {{ selectedAsset?.name ?
  '('+selectedAsset?.name+')' : ''}}</h3>

<form [formGroup]="dialogForm">

  <mat-label style="margin-left: 5px;">Select Type <sup>*</sup></mat-label>
  <mat-form-field appearance="outline" style="margin: 5px;">
    <mat-select formControlName="type" (selectionChange)="onTypeSelectionChange($event.value)">
      <mat-option *ngFor="let type of types" [value]="type.value">
        {{type.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Menu Start-->
  <mat-label style="margin-left: 5px">Select Option <sup>*</sup></mat-label>
  <mat-form-field (click)="levelOneTrigger.openMenu()" appearance="outline" style="margin: 5px;">
    <mat-select #mySelect formControlName="selectedOption" placeholder="Select..." [disabled]="true"
      [matMenuTriggerFor]="levelOne" #levelOneTrigger="matMenuTrigger">
      <mat-option *ngFor="let category of selectionList" [value]="category">
        {{ category }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-menu #levelOne="matMenu" direction="down" yPosition="below">
    <button mat-menu-item *ngIf="modelName && dialogForm.get('type')?.value === assetTableTypes.TAG " (click)="showModelTags()">
      {{modelName}} </button>
    <ng-container *ngFor="let menuItem of componentsDetail">
      <span (mouseleave)="levelOneTrigger.closeMenu()"> </span>
      <ng-container>
        <li mat-menu-item [matMenuTriggerFor]="levelTwo">
          <span>{{ menuItem.name }}</span>
        </li>
        <mat-menu #levelTwo="matMenu">
          <ng-container *ngFor="let child2 of menuItem?.children">
            <button mat-menu-item (click)="componentChanged(child2)">
              {{ child2?.componentInstanceName }}
            </button>
          </ng-container>
        </mat-menu>
      </ng-container>
    </ng-container>
  </mat-menu>
  <!-- Menu End-->
</form>

<br>
<hr />

<div class="grid-container">

  <div fxLayout="row" fxLayoutAlign="space-between center">
    <mat-form-field appearance="outline" style="width: 250px; margin-top: 5px;">
      <mat-label>Search</mat-label>
      <input matInput type="text" (input)="filterGrid($event.target.value)" autocomplete="off" />
    </mat-form-field>

    <button type="button" [disabled]="disableSave" mat-icon-button title="Save" (click)="save()" style="margin-bottom: 30px;">
      <mat-icon>save</mat-icon>
    </button>
  </div>

  <ag-grid-angular style="width: 100%; height: 500px;" class="ag-theme-material" [pagination]="true"
    [paginationPageSize]="15" [columnDefs]="columnDefs" [modules]="modules" [defaultColDef]="defaultColDef"
    [sideBar]="sideBar" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)"
    (selectionChanged)="onRowSelectionChanged($event)" (rowClicked)="onRowClick($event)" #agGrid>
  </ag-grid-angular>
</div>